export default __webpack_public_path__ + "static/media/lacakio_color_logo_only.f9f41df5.svg";